import type { MMediaImageProps } from '../MMediaImage/MMediaImage.types';
import type { MMediaCarouselProps } from '../MMediaCarousel/MMediaCarousel.types';
import type { MCtaThumbnailProps } from '../MCtaThumbnail/MCtaThumbnail.types';
import type { MVideoThumbnailProps } from '../MVideoThumbnail/MVideoThumbnail.types';
import type { MVideoBackgroundProps } from '../MVideoBackground/MVideoBackground.types';

export enum MMediaSelectorMediaType {
  Image = 'Image',
  Carousel = 'Carousel',
  ModalVideo = 'Modal Video',
  AutoplayVideo = 'Autoplay Video',
  CTAOverlay = 'CTA Overlay',
}

export interface MMediaSelectorProps extends React.HTMLAttributes<HTMLDivElement> {
  mediaType?: MMediaSelectorMediaType;
  mMediaImage?: MMediaImageProps;
  mMediaCarousel?: MMediaCarouselProps;
  mCtaThumbnail?: MCtaThumbnailProps;
  mVideoThumbnail?: MVideoThumbnailProps;
  mVideoBackground?: MVideoBackgroundProps;
  className?: string;
}

export type { MMediaImageProps, MMediaCarouselProps, MCtaThumbnailProps, MVideoThumbnailProps, MVideoBackgroundProps };
